import WhiteBoard from './WhiteBoard'

export default WhiteBoard


// WEBPACK FOOTER //
// ./src/board/WhiteBoard/index.js